export default __webpack_public_path__ + "static/media/bell.e410a43f.mp3";